import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "browse-reference" }
const _hoisted_2 = ["onClick"]

import {watch} from 'vue';
import { useTrucodeReferenceStore } from 'stores/references-store';
import {storeToRefs} from 'pinia';
import { TitledObject } from 'src/services/TrucodeReferencesService';

type LazyLoadDetails = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  node: any;
  key: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  done: (children?: readonly any[]) => void;
  fail: () => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferencesBrowse',
  setup(__props) {

const referenceStore = useTrucodeReferenceStore();
const { currentBrowseBook, browseNodes, browseSelectedArticleNode, browseExpandedNodes } = storeToRefs(referenceStore);

function onSelectionChanged(node: TitledObject) {
  if(node?.id && node?.type == 'article') {
    referenceStore.setCurrentArticle(node);
  }
}

watch(currentBrowseBook, async (newBook) => {
  if (newBook?.id) {
    let years =  await referenceStore.getBookReferenceYears(newBook.id) || [];
    browseNodes.value = years.map(year => {
      return {
        id: '' + year,
        type: 'year',
        title: '' + year,
        lazy: true,
        selectable: false
      }});
  }
});

async function loadIssues(id: number) {
  return (await referenceStore.getBookReferenceYearIssue(id) || []).map(result => {
    result.type = 'issue';
    result.lazy = true;
    result.selectable = false;
    return result;
  });
}

async function loadArticles(id: number) {
  return (await referenceStore.getReferencesArticles(id) || []).map(result => {
    result.type = 'article';
    result.selectable = true;
    return result;
  });
}

// copied from quasar
async function loadNodes({ node, key, done, fail }: LazyLoadDetails): Promise<void> {
  try {
    switch(node.type) {
      case 'year':
        done(await loadIssues(+key));
        break;
      case 'issue':
        done(await loadArticles(+key));
        break;
    }
  }catch (err) {
    fail();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_tree = _resolveComponent("q-tree")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_tree, {
      nodes: _unref(browseNodes),
      "node-key": "id",
      "no-connectors": "",
      icon: "fa-solid fa-caret-right",
      class: "iodine-padding-left-lg",
      selected: _unref(browseSelectedArticleNode),
      "onUpdate:selected": _cache[0] || (_cache[0] = ($event: any) => (_isRef(browseSelectedArticleNode) ? (browseSelectedArticleNode).value = $event : null)),
      expanded: _unref(browseExpandedNodes),
      "onUpdate:expanded": _cache[1] || (_cache[1] = ($event: any) => (_isRef(browseExpandedNodes) ? (browseExpandedNodes).value = $event : null)),
      onLazyLoad: loadNodes
    }, {
      "default-header": _withCtx((prop) => [
        _createElementVNode("div", {
          class: "row items-center browse-result-item iodine-padding-left-sm",
          onClick: ($event: any) => (onSelectionChanged(prop.node))
        }, [
          _createElementVNode("div", null, _toDisplayString(prop.node.title), 1)
        ], 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["nodes", "selected", "expanded"])
  ]))
}
}

})